import React, { useState, useEffect, useRef } from 'react';

import { FormattedMessage, useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';
import { CloseIcon } from '../../Atoms/Icons/Icons';
import { Button } from '../../Molecules/Button/Button';

import './PopinAccessibility.scss';

const PopinAccessibility = () => {
  const popinRef = useRef();
  const [contrast, setContrast] = useState('a42-ac-default-contrast');
  const [fonts, setFonts] = useState('a42-ac-default-font');
  const [line_height, setLineHeight] = useState('a42-ac-default-spacing');

  const intl = useIntl();

  useEffect(() => {
    const contrast_cookie = getCookie('a42-ac-contrast');
    const fonts_cookie = getCookie('a42-ac-font');
    const line__height_cookie = getCookie('a42-ac-line-spacing');
    setContrast(contrast_cookie);
    setFonts(fonts_cookie);
    setLineHeight(line__height_cookie);

    if (popinRef.current) {
      popinRef.current.addEventListener('keydown', onKeyPressed)
      return () => { popinRef.current ? popinRef.current.removeEventListener('keydown', onKeyPressed) : null };
    }

  }, []);

  const onKeyPressed = (e) => {
    if (e.keyCode === 9 && e.target.classList.contains('btn_close')) {
      e.preventDefault();
      popinRef.current.querySelectorAll('.btn')[0].focus();
    }
  }


  useEffect(() => {
    if (
      (!contrast || !fonts || !line_height)
    ) {
      return false;
    }

    const addBodyAccessibilityClasses = () => {
      const body = document.body;
      body.classList.remove('a42-ac-default-contrast', 'a42-ac-high-contrast', 'a42-ac-inv-contrast', 'a42-ac-default-font', 'a42-ac-dys-font', 'a42-ac-default-spacing', 'a42-ac-dys-spacing');
      body?.classList.add(contrast, fonts, line_height);
    };

    addBodyAccessibilityClasses();
    setCookie('a42-ac-contrast', contrast, 2);
    setCookie('a42-ac-font', fonts, 2);
    setCookie('a42-ac-line-spacing', line_height, 2);
  }, [contrast, fonts, line_height]);

  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  };
  const getCookie = (name) => {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const handleAccessibiliteBtnClicked = (e) => {
    if (e.currentTarget.dataset.type === 'contrast') {
      setContrast(e.currentTarget.value);
    }
    if (e.currentTarget.dataset.type === 'fonts') {
      setFonts(e.currentTarget.value);
    }
    if (e.currentTarget.dataset.type === 'line_height') {
      setLineHeight(e.currentTarget.value);
    }
  };

  const onHideAccessibilite = (e) => {
    e.preventDefault();
    document.body.classList.remove('show_accessibility_popin');
    if (document.querySelector('a.accessibilite')) {
      document.querySelector('a.accessibilite').focus();
    }
  };

  return (
    <div className="popin_accessibilite" ref={popinRef} role="dialog" aria-labelledby="accessmodaltitle" id="popin_accessibilite">
      <div className="popin_content">
        <div className="content_wrapper">
          <FormattedMessage id="accessibility.title">{x => <h1 id="accessmodaltitle">{x}</h1>}</FormattedMessage>
          <div className="col_3">
            <div className="col_1">
              <FormattedMessage id="accessibility.contrast.title">{x => <h2>{x}</h2>}</FormattedMessage>
              <Button
                value='a42-ac-default-contrast'
                data-type='contrast'
                inactive={contrast != 'a42-ac-default-contrast' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.contrast.options.default' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={contrast != 'a42-ac-default-contrast' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_contrast_default' })}
              />
              <Button
                value='a42-ac-high-contrast'
                data-type='contrast'
                inactive={contrast != 'a42-ac-high-contrast' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.contrast.options.reinforce' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={contrast != 'a42-ac-high-contrast' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_contrast_reinforce' })}
              />
              <Button
                value='a42-ac-inv-contrast'
                data-type='contrast'
                inactive={contrast != 'a42-ac-inv-contrast' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.contrast.options.inverse' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={contrast != 'a42-ac-inv-contrast' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_contrast_reverse' })}
              />
            </div>
            <div className="col_1">
              <FormattedMessage id="accessibility.font.title">{x => <h2>{x}</h2>}</FormattedMessage>
              <Button
                value='a42-ac-default-font'
                data-type='fonts'
                inactive={fonts != 'a42-ac-default-font' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.font.options.default' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={fonts != 'a42-ac-default-font' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_font_default' })}
              />
              <Button
                value='a42-ac-dys-font'
                data-type='fonts'
                inactive={fonts != 'a42-ac-dys-font' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.font.options.adapt' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={fonts != 'a42-ac-dys-font' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_font_adapt' })}
              />
            </div>
            <div className="col_1">
              <FormattedMessage id="accessibility.interline.title">{x => <h2>{x}</h2>}</FormattedMessage>
              <Button
                value='a42-ac-default-spacing'
                data-type='line_height'
                inactive={line_height != 'a42-ac-default-spacing' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.interline.options.default' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={line_height != 'a42-ac-default-spacing' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_line_height_default' })}
              />
              <Button
                value='a42-ac-dys-spacing'
                data-type='line_height'
                inactive={line_height != 'a42-ac-dys-spacing' ? true : false}
                label={intl.formatMessage({ id: 'accessibility.interline.options.reinforce' })}
                size='large'
                onClick={(e) => handleAccessibiliteBtnClicked(e)}
                aria-current={line_height != 'a42-ac-dys-spacing' ? 'false' : 'true'}
                aria-label={intl.formatMessage({ id: 'ariaLabel.popin_access_line_height_reinforce' })}
              />
            </div>
          </div>
        </div>
        <div className="div_btn_close">
          <a href="#" aria-label={intl.formatMessage({ id: 'ariaLabel.close_modal' })} className="btn_close" onClick={(e) => onHideAccessibilite(e)}>
            <CloseIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PopinAccessibility;
